const formatDateShort = (date: string): string => {
  let formatedDate;

  if (Date.parse(date)) {
    const dateItem = new Date(date);
    formatedDate = dateItem.toLocaleDateString('en-GB', {
      month: 'short',
      day: '2-digit',
    });

    if (new Date().toDateString() === dateItem.toDateString()) {
      formatedDate += ' (today)';
    }
  } else {
    formatedDate = '';
  }

  return formatedDate;
};

export default formatDateShort;
